<template>
  <div class="report_wrap" ref="turtor">
    <div class="repost_mobile_shiying">
      <div class="report_options">
        <el-row class="option" type="flex" justify="space-between">
          <el-col class="option_item" v-for="(item, index) in optionsList" :key="index"
            @click.native="changeOptionIndex(index)">
            <div class="item_bottom" :class="optionActive === index ? 'active' : ''">
              {{ item.txt }}
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 公司动态内容 -->
      <div class="report_avtive_wrap" v-show="optionActive === 0">
        <div class="book_list">
          <div class="news_list">
            <div v-for="(news, index) in newsList" :key="index" class="news_item">
              <div class="news_image">
                <img :src="news.image" alt="" />
              </div>
              <div class="news_content">
                <div class="title">{{ news.title }}</div>
                <p>{{ news.content }}</p>
                <div class="news_info">
                  <span>分类：{{ news.category }}</span>
                  <span>时间：{{ news.date }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 媒体报道内容 -->
      <!-- <div class="report_avtive_wrap" v-show="optionActive === 2">
        <div class="book_list book_list_speial">
          <p style="font-size: 12px">
            共<span style="color: #2091d3; padding: 0 6px">{{ mediaList.length }}</span>篇媒体报道
          </p>
          <el-row class="card_list" type="flex" justify="space-between">
            <el-col class="card_item" v-for="(item, index) in mediaList" :key="index"
              @click.native="handleNewsDetails(item.url)">
              <div class="item_left">
                <img :src="item.img" alt="" />
              </div>
              <div class="item_right">
                <h1>{{ item.title }}</h1>
                <p>{{ item.intro }}</p>
                <p>{{ item.createTime }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core'
import Pullup from '@better-scroll/pull-up'
import MouseWheel from '@better-scroll/mouse-wheel'
BScroll.use(Pullup)
BScroll.use(MouseWheel)

export default {
  data() {
    return {
      optionsList: [
        {
          icon: require('@/assets/img/63.png'),
          txt: '公司动态',
        },
        {
          icon: require('@/assets/img/64.png'),
          txt: '三益故事',
        },
        {
          icon: require('@/assets/img/65.png'),
          txt: '技术培训',
        },
      ],
      optionActive: 0,
      newsList: [
        {
          image: require('@/assets/img/banner.webp'),
          title: '长沙市开福区民政局7月份安全生产调度会在普亲养老·长沙东风路院举行',
          content: '为进一步强化全区养老机构安全生产主体责任，切实提升安全管理水平，有效防范化解各类安全风险隐患，7月24日，长沙市开福区民政局在普亲养...',
          category: '新闻资讯',
          date: '2025-07-24'
        },
        {
          image: require('@/assets/img/banner.webp'),
          title: '湖南信海康向普亲捐赠药品 助力守护长者健康',
          content: '6月19日，湖南信海康医药咨询有限公司向普亲养老·长沙桂花坪院捐赠了一批价值二十余万元的药品，以实际行动关爱老年群体，践行企业社会责...',
          category: '新闻资讯',
          date: '2025-06-20'
        },
        {
          image: require('@/assets/img/banner.webp'),
          title: '湖南爱晚频道走进普亲开展“走找想促”专题活动',
          content: '5月19日上午，湖南公共传媒（爱晚频道）党总支书记、总经理刘志忠率领团队来到普亲养老·长沙东风路院，开展“走基层、找问题、想办法、促发...',
          category: '新闻资讯',
          date: '2025-05-19'
        },
        {
          image: require('@/assets/img/banner.webp'),
          title: '长沙市民政局带队指导普亲养老·长沙东风路院开展消防演练',
          content: '为了进一步提升全体人员的消防安全意识，增强应对火灾的应急处置能力，5月14日下午，在长沙市民政局、开福区民政局、东风路街道办的指导下...',
          category: '新闻资讯',
          date: '2025-05-15'
        }
      ],
      mediaList: [],
      scroll: null,
    }
  },
  mounted() {
    // 初始化滚动条
    this.scroll = new BScroll(this.$refs.listScroll, {
      scrollX: true,
      eventPassthrough: 'vertical',
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300,
      },
    })

    // 获取媒体报道数据
    this.axios.get('http://glowworm.club:9093/mediaList.json')
      .then((res) => {
        this.mediaList = res.data.mediaList
      })
      .catch((err) => {
        console.log(err.message)
      })
  },
  methods: {
    changeOptionIndex(index) {
      this.optionActive = index
    },
    handleNewsDetails(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.report_wrap {
  width: 72vw;
  margin: 0 auto;

  .repost_mobile_shiying {
    .report_options {
      width: 100%;
      height: 120px;
      margin-top: 4.2rem;

      .option {
        width: 70%;
        margin: 0 auto;
        align-items: center;

        .option_item {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          cursor: pointer;

          .item_bottom {
            font-weight: bold;
            font-size: 1.4rem;
            border: solid 0.1rem transparent;
            padding: 1rem;
            border-radius: 0.5rem;

            &.active {
              color: #ff7000;
              border: solid 0.1rem #ff7000;
            }
          }
        }
      }
    }

    .book_list {
      .news_list {
        .news_item {
          display: flex;
          margin-bottom: 1.2rem;
          border-bottom: 1px solid #eee;
          padding-bottom: 2rem;

          // &:last-child {
          //   border-bottom: none;
          // }

          .news_image {
            width: 16rem;
            height: 10.5rem;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .news_content {
            flex: 1;
            padding: 0 4rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .title {
              font-size: 1.4rem;
              margin-bottom: 10px;
              color: #333;
            }

            p {
              color: #666;
              line-height: 1.5;
              font-size: 0.9rem;
              margin-bottom: 0.9rem;
            }

            .news_info {
              color: #999;
              font-size: 0.9rem;

              span {
                &:last-child {
                  margin-left: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>